export const onstreetDeliveryMarkerDataSelector = ({onstreetDeliveryMarkerData}) => onstreetDeliveryMarkerData